import { EventEmitter } from 'events';
import { PresenceSelectionProps } from '../presenceSignal';

export enum ComponentPresenceEvent {
  PresenceChanged = 'presenceChanged'
}

declare module '@fluidframework/core-interfaces' {
  // tslint:disable-next-line:interface-name
  export interface IFluidObject extends Readonly<Partial<IProvideComponentProvidePresence>> {}
}

// tslint:disable-next-line:interface-name
export interface IProvideComponentProvidePresence {
  readonly IComponentProvidePresence: IComponentProvidePresence;
}

/*
 Components can provide user presence information via implementing this interface
*/
// tslint:disable-next-line:interface-name
export interface IComponentProvidePresence extends IProvideComponentProvidePresence, EventEmitter {
  /*
   * Gets component presence information.
   */
  getPresenceInformation(): ComponentPresenceInformation;

  on(
    event: ComponentPresenceEvent.PresenceChanged,
    listener: (clientId: string, presence: PresenceSelectionProps | undefined) => void
  ): this;
}

export class ComponentPresence extends EventEmitter implements IComponentProvidePresence {
  public constructor(private readonly getPresenceInformationCallback: () => ComponentPresenceInformation) {
    super();
  }

  public get IComponentProvidePresence() {
    return this;
  }

  /*
   * Gets component presence information.
   */
  public getPresenceInformation(): ComponentPresenceInformation {
    return this.getPresenceInformationCallback();
  }

  public emitPresenceChangeEvent(clientId: string, presence: PresenceSelectionProps | undefined): void {
    this.emit(ComponentPresenceEvent.PresenceChanged, clientId, presence);
  }
}

export type ComponentPresenceInformation = { [clientId: string]: PresenceSelectionProps | undefined };
